import { ReactNode } from 'react';
import { FlexCol, FlexRowMiddle } from './Flex';
import styled from 'styled-components';
import { Text } from './Text';
import { GridRow } from './Grid';

const StyledInputRow = styled(FlexCol)``;

export function InputRow({
	label,
	children,
	childrenFooter,
}: {
	label?: string;
	children: ReactNode;
	childrenFooter?: ReactNode;
}) {
	return (
		<StyledInputRow>
			<FlexCol style={{ rowGap: '0.5rem' }}>
				<Text $color="text_title_alt" $size="1.2rem" $weight="400">
					{label}
				</Text>
				{children}
			</FlexCol>
			{childrenFooter ?? childrenFooter}
		</StyledInputRow>
	);
}

export function InputCol({
	label,
	children,
	childrenFooter,
	reverse,
}: {
	reverse?: boolean;
	label?: string;
	children: ReactNode;
	childrenFooter?: ReactNode;
}) {
	return (
		<StyledInputRow>
			<FlexRowMiddle style={{ columnGap: '0.5rem' }}>
				<Text $color="text_title_alt" $size="1.2rem" $weight="400" style={{ order: reverse ? 1 : undefined }}>
					{label}
				</Text>
				{children}
			</FlexRowMiddle>
			{childrenFooter ?? childrenFooter}
		</StyledInputRow>
	);
}

export const FormRow = styled(GridRow)<{ $columns?: string }>`
	margin-bottom: 1.5rem;
	column-gap: 1rem;
	grid-template-columns: ${({ $columns }) => $columns ?? 'repeat(auto-fit, minmax(10px, 1fr))'};
	&:last-of-type {
		margin-bottom: 0;
	}
`;
